import React, { useState, useEffect, useRef, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import kouLogo from "../images/koulogo.png";
import studentHomeImg2 from "../images/adminhome.svg";
import api from "../services/api";
import "./pagesStyles/UnitHomePage.css";
import UnitMonthlyTable from "../components/UnitMonthlyTable"; // NEW

import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
window.html2canvas = html2canvas;
window.jspdf = { jsPDF };

function UnitHomePage() {
  const [activeTab, setActiveTab] = useState("basvurular");
  const [unitData, setUnitData] = useState(null);
  const [applications, setApplications] = useState([]);
  const [loading, setLoading] = useState(true);
  const [viewingDocument, setViewingDocument] = useState(null);
  const [documentUrl, setDocumentUrl] = useState(null);
  const [documentPreviewLoading, setDocumentPreviewLoading] = useState(false);
  const [documentPreviewError, setDocumentPreviewError] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [applicationsPerPage] = useState(5);
  const [asilYedekPdfUrl, setAsilYedekPdfUrl] = useState(null);
  const [promotionModalOpen, setPromotionModalOpen] = useState(false);
  const [shortages, setShortages] = useState([]);
  const [selectedPromotions, setSelectedPromotions] = useState({}); // { [workplaceId]: Set<applicationId> }
  const [promoting, setPromoting] = useState(false);
  const pdfContainerRef = useRef(null);
  const asilYedekContainerRef = useRef(null);
  const resizeTimerRef = useRef(null); // responsive: debounce timer
  const navigate = useNavigate(); // NEW
  const logoutTimerRef = useRef(null); // NEW
  const [notifications, setNotifications] = useState([]);   // NEW
  const [unreadCount, setUnreadCount] = useState(0);        // NEW
  const [notifOpen, setNotifOpen] = useState(false);        // NEW
  const [notifLoading, setNotifLoading] = useState(false);  // NEW

  // NEW: Aylık takip state
  const [monthlyAvailable, setMonthlyAvailable] = useState(false);
  const [monthlyMonth, setMonthlyMonth] = useState(() => {
    const now = new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, "0")}`;
  });
  const [monthlyData, setMonthlyData] = useState(null);
  const [monthlyLoading, setMonthlyLoading] = useState(false);

  // NEW: soft refresh flag to avoid full-page loader flicker
  const [refreshing, setRefreshing] = useState(false);

  // NEW: polling state/refs
  const [appsMetaVersion, setAppsMetaVersion] = useState(0);
  const pollTimerRef = useRef(null);
  const pollBackoffRef = useRef(12000); // start 12s

  // NEW: notification polling refs/state
  const [notifMetaVersion, setNotifMetaVersion] = useState(0);
  const notifPollTimerRef = useRef(null);
  const notifPollBackoffRef = useRef(12000);

  const [asilYedekRows, setAsilYedekRows] = useState([]); // NEW: asil/yedek belge gönderenler

 const loadPdfJs = () =>
  new Promise((resolve, reject) => {
    if (window.pdfjsLib) return resolve(window.pdfjsLib);
    const script = document.createElement("script");
    script.src = "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.10.111/pdf.min.js";
    script.onload = () => {
      window.pdfjsLib.GlobalWorkerOptions.workerSrc =
        "https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.10.111/pdf.worker.min.js";
      resolve(window.pdfjsLib);
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });

const renderPdf = async (url) => {
  try {
    const pdfjsLib = await loadPdfJs();
    const container = pdfContainerRef.current;
    if (!container) return;
    container.innerHTML = "";

    const loadingTask = pdfjsLib.getDocument(url);
    const pdf = await loadingTask.promise;

    for (let pageNum = 1; pageNum <= pdf.numPages; pageNum++) {
      const page = await pdf.getPage(pageNum);
      const baseViewport = page.getViewport({ scale: 1 });
      const containerWidth = container.clientWidth || 800;
      const cssScale = containerWidth / baseViewport.width;
      const dpr = window.devicePixelRatio || 1;
      const renderViewport = page.getViewport({ scale: cssScale * dpr });

      const canvas = document.createElement("canvas");
      canvas.className = "pdf-canvas";
      const ctx = canvas.getContext("2d");
      canvas.width = Math.ceil(renderViewport.width);
      canvas.height = Math.ceil(renderViewport.height);
      canvas.style.width = `${Math.ceil(renderViewport.width / dpr)}px`;
      canvas.style.height = `${Math.ceil(renderViewport.height / dpr)}px`;
      container.appendChild(canvas);

      await page.render({ canvasContext: ctx, viewport: renderViewport }).promise;
    }
  } catch (e) {
    console.error("PDF render error:", e);
  }
};

const renderAsilYedekPdf = async (url) => {
  try {
    const pdfjsLib = await loadPdfJs();
    const container = asilYedekContainerRef.current;
    if (!container) return;
    container.innerHTML = "";

    // PDF'den veriyi çek
    const loadingTask = pdfjsLib.getDocument(url);
    const pdf = await loadingTask.promise;

    // Outer wrapper - bu element indirilecek
    const pdfWrapper = document.createElement("div");
    pdfWrapper.id = "printable-pdf-wrapper";
    pdfWrapper.style.cssText = `
      background: white;
      border-radius: 16px;
      padding: 40px 50px;
      margin: 20px auto;
      max-width: 1400px;
    `;

    // Logo ve başlık bölümü
    const header = document.createElement("div");
    header.style.cssText = `
      display: flex;
      align-items: flex-start;
      justify-content: space-between;
      margin-bottom: 20px;
      padding-bottom: 10px;
      border-bottom: 2px solid #000;
    `;
    
    // Logo sol tarafta
    const logoDiv = document.createElement("div");
    logoDiv.style.cssText = `
      flex-shrink: 0;
    `;
    
    const logo = document.createElement("img");
    logo.src = kouLogo;
    logo.alt = "Kocaeli Üniversitesi";
    logo.style.cssText = `
      height: 70px;
      width: auto;
      object-fit: contain;
    `;
    logoDiv.appendChild(logo);
    
    // Başlıklar sağda
    const titleContainer = document.createElement("div");
    titleContainer.style.cssText = `
      flex: 1;
      text-align: center;
      padding-left: 20px;
    `;
    
    const title1 = document.createElement("div");
    title1.textContent = "T.C.";
    title1.style.cssText = `
      font-size: 14px;
      font-weight: normal;
      margin-bottom: 8px;
      color: #000;
    `;
    
    const title2 = document.createElement("div");
    title2.textContent = "KOCAELİ ÜNİVERSİTESİ";
    title2.style.cssText = `
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 10px;
      color: #000;
      letter-spacing: 2px;
    `;
    
    const title3 = document.createElement("div");
    title3.textContent = "KISMI ZAMANLI ÖĞRENCİ ASİL VE YEDEK LİSTESİ";
    title3.style.cssText = `
      font-size: 15px;
      font-weight: 600;
      color: #000;
    `;
    
    titleContainer.appendChild(title1);
    titleContainer.appendChild(title2);
    titleContainer.appendChild(title3);
    
    header.appendChild(logoDiv);
    header.appendChild(titleContainer);
    pdfWrapper.appendChild(header);

    // Tablo container
    const tableContainer = document.createElement("div");
    tableContainer.style.cssText = `
      margin-top: 30px;
      border-radius: 15px;
      overflow: hidden;
      border: 1px solid #000;
    `;

    // Tablo oluştur
    const table = document.createElement("table");
    table.style.cssText = `
      width: 100%;
      border-collapse: collapse;
      background: white;
    `;

    // Tablo başlığı - birim adı
    const theadUnit = document.createElement("thead");
    const trUnit = document.createElement("tr");
    const thUnit = document.createElement("th");
    thUnit.colSpan = 5; // 4'ten 5'e çıktı
    thUnit.textContent = "Bilgisayar Araştırma ve Uygulama Merkezi"; // Buraya dinamik birim adı gelecek
    thUnit.style.cssText = `
      background: #ffffffff;
      padding: 5px;
      text-align: center;
      font-size: 18px;
      font-weight: 400;
      border-bottom: 1px solid #000;
    `;
    trUnit.appendChild(thUnit);
    theadUnit.appendChild(trUnit);
    table.appendChild(theadUnit);

    // Tablo header - kolon başlıkları
    const thead = document.createElement("thead");
    const trHeader = document.createElement("tr");
    
    const headers = ["Sıra", "T.C. Kimlik No", "Ad - Soyad", "Görevi", "Durum"];
    headers.forEach((headerText, index) => {
      const th = document.createElement("th");
      th.textContent = headerText;
      th.style.cssText = `
        background: white;
        padding: 8px;
        text-align: ${index === 0 || index === 4 ? 'center' : 'left'};
        font-size: 14px;
        font-weight: 600;
        border: 1px solid #000;
        border-top: none;
        ${index === 0 ? 'width: 60px;' : ''}
        ${index === 4 ? 'width: 100px;' : ''}
      `;
      trHeader.appendChild(th);
    });
    thead.appendChild(trHeader);
    table.appendChild(thead);

    // Tablo body - veriler
    const tbody = document.createElement("tbody");
    
    // DEĞİŞTİ: sampleData yerine asilYedekRows kullan
    (asilYedekRows.length > 0 ? asilYedekRows : []).forEach((row) => {
      const tr = document.createElement("tr");
      
      const tdSira = document.createElement("td");
      tdSira.textContent = row.sira;
      tdSira.style.cssText = `
        padding: 10px;
        text-align: center;
        border: 1px solid #000;
        font-size: 14px;
      `;
      const tdTc = document.createElement("td");
      tdTc.textContent = row.tcKimlik;
      tdTc.style.cssText = `
        padding: 10px;
        border: 1px solid #000;
        font-size: 14px;
      `;
      const tdAd = document.createElement("td");
      tdAd.textContent = row.adSoyad;
      tdAd.style.cssText = `
        padding: 10px;
        border: 1px solid #000;
        font-size: 14px;
      `;
      const tdGorev = document.createElement("td");
      tdGorev.textContent = row.gorevi;
      tdGorev.style.cssText = `
        padding: 10px;
        border: 1px solid #000;
        font-size: 14px;
      `;
      const tdDurum = document.createElement("td");
      tdDurum.textContent = row.durum;
      tdDurum.style.cssText = `
        padding: 10px;
        text-align: center;
        border: 1px solid #000;
        font-size: 14px;
        color: #000; 
      `;
      tr.appendChild(tdSira);
      tr.appendChild(tdTc);
      tr.appendChild(tdAd);
      tr.appendChild(tdGorev);
      tr.appendChild(tdDurum);
      tbody.appendChild(tr);
    });

    table.appendChild(tbody);
    tableContainer.appendChild(table);
    pdfWrapper.appendChild(tableContainer);
    container.appendChild(pdfWrapper);

  } catch (e) {
    console.error("Asil-Yedek PDF render error:", e);
  }
};

  const parseFileNameFromDisposition = (disposition) => {
    if (!disposition) return null;
    const starMatch = disposition.match(/filename\*\s*=\s*UTF-8''([^;]+)/i);
    if (starMatch && starMatch[1]) {
      try { return decodeURIComponent(starMatch[1].replace(/\"/g, "")); } catch { return starMatch[1]; }
    }
    const match = disposition.match(/filename\s*=\s*\"?([^\";]+)\"?/i);
    if (match && match[1]) return match[1];
    return null;
  };

  const getExtensionForContentType = (value) => {
    const type = String(value || "").split(";")[0].trim().toLowerCase();
    if (type === "application/pdf") return ".pdf";
    if (type === "application/msword") return ".doc";
    if (type === "application/vnd.openxmlformats-officedocument.wordprocessingml.document") return ".docx";
    if (type === "application/vnd.ms-excel") return ".xls";
    if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return ".xlsx";
    return "";
  };

  const triggerDownloadFromUrl = (url, fileName) => {
    const link = document.createElement("a");
    link.href = url;
    if (fileName) link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const isExcelFile = (contentType, fileName) => {
    const type = String(contentType || "").split(";")[0].trim().toLowerCase();
    if (type === "application/vnd.ms-excel") return true;
    if (type === "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet") return true;
    if (fileName && /\.(xls|xlsx)$/i.test(fileName)) return true;
    return false;
  };

  const convertExcelBlobToPdf = async (blob, fileName = "document.xlsx") => {
    const buffer = await blob.arrayBuffer();
    const workbook = XLSX.read(buffer, { type: "array", raw: false, cellDates: true });
    const sheetNames = workbook.SheetNames || [];
    const doc = new jsPDF({ orientation: "landscape", unit: "pt", format: "a4" });

    if (sheetNames.length === 0) {
      doc.setFontSize(12);
      doc.text(`Empty workbook: ${fileName}`, 40, 40);
      return doc.output("blob");
    }

    sheetNames.forEach((sheetName, index) => {
      if (index > 0) doc.addPage();
      doc.setFontSize(11);
      doc.text(String(sheetName), 40, 30);

      const sheet = workbook.Sheets[sheetName];
      const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, defval: "" });
      if (!rows || rows.length === 0) {
        doc.setFontSize(9);
        doc.text("No data", 40, 50);
        return;
      }

      const maxCols = Math.max(...rows.map((row) => (row ? row.length : 0)), 0);
      const normalizeRow = (row) =>
        Array.from({ length: maxCols }, (_, i) => (row && row[i] != null ? String(row[i]) : ""));

      const head = [normalizeRow(rows[0] || [])];
      const body = rows.slice(1).map(normalizeRow);

      autoTable(doc, {
        startY: 40,
        head,
        body,
        styles: { fontSize: 7, cellPadding: 2, overflow: "linebreak" },
        headStyles: { fillColor: [30, 165, 78], textColor: 255 },
        theme: "grid"
      });
    });

    return doc.output("blob");
  };


  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (viewingDocument && documentUrl && !documentPreviewLoading && !documentPreviewError) {
      renderPdf(documentUrl);
    }
  }, [viewingDocument, documentUrl, documentPreviewLoading, documentPreviewError, renderPdf]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    // initial load should show loader
    fetchUnitApplications({ silent: false });
    // NEW: trigger daily reminder tick (idempotent)
    (async () => { try { await api.post("/admin/reminders/period-end/tick"); } catch {} })();
  }, []);

  const getUnitUser = () => {
    try {
      const s1 = sessionStorage.getItem('unitUser');
      if (s1) return JSON.parse(s1);
      const l1 = localStorage.getItem('unitUser');
      if (l1) return JSON.parse(l1);
      const fallback = localStorage.getItem('user');
      if (fallback) {
        const u = JSON.parse(fallback);
        return u?.type === 'unit' ? u : null;
      }
      return null;
    } catch { return null; }
  };

  // Accept options.silent to avoid showing the full loader
  const fetchUnitApplications = async (options = { silent: false }) => {
    const { silent } = options;
    try {
      if (silent) setRefreshing(true); else setLoading(true);
      const userData = getUnitUser();
      if (!userData || !userData.sicilNo) {
        alert('Giriş bilgileriniz bulunamadı. Lütfen tekrar giriş yapınız.');
        return;
      }

      const response = await api.get(`/unit/${userData.sicilNo}/applications`);
      if (response.data.success) {
        setUnitData(response.data.data.unit);
        // shallow compare to prevent unnecessary re-renders (reduces flicker)
        const next = response.data.data.applications || [];
        setApplications(prev => {
          if (prev.length === next.length) {
            let same = true;
            for (let i = 0; i < prev.length; i++) {
              const a = prev[i], b = next[i];
              if (!a || !b || a._id !== b._id || a.status !== b.status || !!a.hasSubmittedDocuments !== !!b.hasSubmittedDocuments) {
                same = false; break;
              }
            }
            if (same) return prev;
          }
          return next;
        });
      }

      // NEW: refresh current version after full fetch
      try {
        const metaResp = await api.get(`/unit/${userData.sicilNo}/applications`, { params: { meta: 1 } });
        if (metaResp.data?.meta?.version) setAppsMetaVersion(metaResp.data.meta.version);
      } catch {}
    } catch (error) {
      console.error("Başvurular getirilirken hata:", error);
    } finally {
      if (silent) setRefreshing(false); else setLoading(false);
    }
  };

  // NEW: meta poller
  const scheduleUnitPoll = (delayMs) => {
    if (pollTimerRef.current) clearTimeout(pollTimerRef.current);
    pollTimerRef.current = setTimeout(doUnitPoll, delayMs);
  };

  const doUnitPoll = async () => {
    try {
      const user = getUnitUser();
      if (!user?.sicilNo) return;
      if (document.hidden || activeTab !== "basvurular" || viewingDocument) {
        // pause while hidden or not on tab / viewing doc
        scheduleUnitPoll(15000);
        return;
      }
      const resp = await api.get(`/unit/${user.sicilNo}/applications`, { params: { meta: 1 } });
      const v = resp.data?.meta?.version || 0;
      if (v && v !== appsMetaVersion) {
        // version changed -> refresh list softly (no full loader)
        await fetchUnitApplications({ silent: true });
      }
      pollBackoffRef.current = 12000; // reset backoff on success
      scheduleUnitPoll(12000);
    } catch {
      // backoff up to 60s
      const next = Math.min((pollBackoffRef.current || 12000) * 2, 60000);
      pollBackoffRef.current = next;
      scheduleUnitPoll(next);
    }
  };

  // NEW: fetch notifications with optional silent flag (no spinner)
  const fetchNotifications = async (options = { silent: false }) => {
    const { silent } = options;
    try {
      const user = getUnitUser();
      if (!user?.sicilNo) return;
      if (!silent) setNotifLoading(true);
      const resp = await api.get(`/unit/notifications/${user.sicilNo}`);
      if (resp.data?.success) {
        setNotifications(resp.data.data.notifications || []);
        setUnreadCount(resp.data.data.unreadCount || 0);
      }
      // also refresh notif meta version after full fetch
      try {
        const metaResp = await api.get(`/unit/notifications/${user.sicilNo}`, { params: { meta: 1 } });
        const v = metaResp.data?.meta?.version || 0;
        const uc = metaResp.data?.meta?.unreadCount;
        if (typeof uc === 'number') setUnreadCount(uc);
        if (v) setNotifMetaVersion(v);
      } catch {}
    } catch {} finally {
      if (!options?.silent) setNotifLoading(false);
    }
  };

  // NEW: schedule + poll for notification meta
  const scheduleNotifPoll = (delayMs) => {
    if (notifPollTimerRef.current) clearTimeout(notifPollTimerRef.current);
    notifPollTimerRef.current = setTimeout(doNotifPoll, delayMs);
  };

  const doNotifPoll = async () => {
    try {
      const user = getUnitUser();
      if (!user?.sicilNo) return;
      if (document.hidden) {
        scheduleNotifPoll(15000);
        return;
      }
      const resp = await api.get(`/unit/notifications/${user.sicilNo}`, { params: { meta: 1 } });
      const meta = resp.data?.meta || {};
      const v = meta.version || 0;
      if (typeof meta.unreadCount === 'number') {
        setUnreadCount(meta.unreadCount); // update badge without modal
      }
      if (v && v !== notifMetaVersion) {
        setNotifMetaVersion(v);
        // If modal open, refresh full list silently; otherwise only badge is enough
        if (notifOpen) {
          await fetchNotifications({ silent: true });
        }
      }
      notifPollBackoffRef.current = 12000;
      scheduleNotifPoll(12000);
    } catch {
      const next = Math.min((notifPollBackoffRef.current || 12000) * 2, 60000);
      notifPollBackoffRef.current = next;
      scheduleNotifPoll(next);
    }
  };

  // EKLENDİ: Aylık puantajı Excel olarak indir
const downloadMonthlyExcel = async () => {
  if (!monthlyData || !monthlyData.rows || !monthlyMonth) {
    alert("Tablo verisi bulunamadı.");
    return;
  }
  // xlsx kütüphanesini dinamik yükle
  if (!window.XLSX) {
    await new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = "https://cdn.sheetjs.com/xlsx-0.20.0/package/dist/xlsx.full.min.js";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }
  const XLSX = window.XLSX;
  const month = monthlyMonth;
  const rows = monthlyData.rows;

  // Başlıklar
  const header = [
    "Sıra",
    "Ad Soyad",
    "Sicil No",
    "Toplam Saat",
    "Toplam Ücret",
    ...monthlyData.days.map(d => d.date) // Her gün için bir sütun
  ];

  // Satırları oluştur
  const data = rows.map((r, idx) => {
    const perDay = r.perDay || {};
    return [
      idx + 1,
      r.studentName || "",
      r.studentSicilNo || "",
      r.totalHours || 0,
      (r.monthlyAmount || 0) + " TL",
      ...monthlyData.days.map(d => perDay[d.day] || 0)
    ];
  });

  // Sheet oluştur
  const ws = XLSX.utils.aoa_to_sheet([header, ...data]);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Aylık Puantaj");

  // Dosya adını oluştur
  const safeName = (unitData?.birimAdi || "birim")
    .toString()
    .replace(/ğ/g, 'g').replace(/Ğ/g, 'G')
    .replace(/ü/g, 'u').replace(/Ü/g, 'U')
    .replace(/ş/g, 's').replace(/Ş/g, 'S')
    .replace(/ı/g, 'i').replace(/İ/g, 'I')
    .replace(/ö/g, 'o').replace(/Ö/g, 'O')
    .replace(/ç/g, 'c').replace(/Ç/g, 'C')
    .replace(/[^a-zA-Z0-9]/g, '_');
  const fileName = `Aylik_Puantaj_${safeName}_${month}.xlsx`;

  XLSX.writeFile(wb, fileName);
};


  // NEW: start/stop notification polling on mount + visibility
  useEffect(() => {
    const onVis = () => { if (!document.hidden) doNotifPoll(); };
    document.addEventListener("visibilitychange", onVis);
    scheduleNotifPoll(800);
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      if (notifPollTimerRef.current) clearTimeout(notifPollTimerRef.current);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // NEW: start/stop polling by tab/visibility
  useEffect(() => {
    const onVis = () => {
      if (!document.hidden && activeTab === "basvurular" && !viewingDocument) {
        // immediate check on focus
        doUnitPoll();
      }
    };
    document.addEventListener("visibilitychange", onVis);

    if (activeTab === "basvurular" && !viewingDocument) {
      scheduleUnitPoll(500); // start shortly
    } else {
      if (pollTimerRef.current) clearTimeout(pollTimerRef.current);
    }
    return () => {
      document.removeEventListener("visibilitychange", onVis);
      if (pollTimerRef.current) clearTimeout(pollTimerRef.current);
    };
  }, [activeTab, viewingDocument]); // eslint-disable-line react-hooks/exhaustive-deps

  const updateApplicationStatus = async (applicationId, status) => {
    try {
      const response = await api.patch(`/unit/applications/${applicationId}/status`, { status });
      if (response.data.success) {
        // Başvuruları yenile (soft)
        fetchUnitApplications({ silent: true });
        // Show success message for asil selection
        if (status === 'asil') {
          alert('Öğrenci başarıyla asil olarak seçildi.');
        }
      }
    } catch (error) {
      console.error("Başvuru durumu güncellenirken hata:", error);
      
      // Show specific capacity error message
      if (error.response?.status === 400 && error.response?.data?.message) {
        alert(error.response.data.message);
      } else {
        alert('Başvuru durumu güncellenirken hata oluştu');
      }
    }
  };

  const tryClientSidePreview = async (application) => {
    try {
      const response = await api.get(`/unit/applications/${application._id}/document`, {
        responseType: "blob"
      });
      const contentType = response.headers?.["content-type"] || "application/octet-stream";
      const disposition = response.headers?.["content-disposition"];
      const fallbackExt = getExtensionForContentType(contentType);
      const fileName =
        parseFileNameFromDisposition(disposition) ||
        `basvuru_${application._id}${fallbackExt || ""}`;
      const blob = new Blob([response.data], { type: contentType });

      if (contentType === "application/pdf") {
        const url = window.URL.createObjectURL(blob);
        setDocumentUrl(url);
        setDocumentPreviewError(null);
        return true;
      }

      if (isExcelFile(contentType, fileName)) {
        const pdfBlob = await convertExcelBlobToPdf(blob, fileName || "document.xlsx");
        const url = window.URL.createObjectURL(pdfBlob);
        setDocumentUrl(url);
        setDocumentPreviewError(null);
        return true;
      }

      return false;
    } catch {
      return false;
    }
  };

  const viewDocument = async (application) => {
    try {
      setViewingDocument(application);
      setDocumentPreviewLoading(true);
      setDocumentPreviewError(null);
      if (documentUrl) {
        try { window.URL.revokeObjectURL(documentUrl); } catch {}
      }
      setDocumentUrl(null);
      const response = await api.get(`/unit/applications/${application._id}/document`, {
        responseType: "blob",
        params: { preview: 1 }
      });
      const contentType = response.headers?.["content-type"] || "application/pdf";
      const url = window.URL.createObjectURL(new Blob([response.data], { type: contentType }));
      setDocumentUrl(url);
    } catch (error) {
      console.error("Belge g?r?nt?lenirken hata:", error);
      const fallbackOk = await tryClientSidePreview(application);
      if (fallbackOk) return;

      let message = "Belge g?r?nt?lenemedi";
      try {
        if (error.response?.data instanceof Blob) {
          const text = await error.response.data.text();
          try {
            const parsed = JSON.parse(text);
            if (parsed?.message) message = parsed.message;
          } catch {
            if (text) message = text;
          }
        }
      } catch {}
      setDocumentPreviewError(message);
      setDocumentUrl(null);
    } finally {
      setDocumentPreviewLoading(false);
    }
  };

  const backToApplications = () => {
    if (documentUrl) {
      window.URL.revokeObjectURL(documentUrl);
    }
    setDocumentUrl(null);
    setDocumentPreviewLoading(false);
    setDocumentPreviewError(null);
    setViewingDocument(null);
  };

  const downloadCurrentDocument = async () => {
    if (!viewingDocument) return;
    try {
      const response = await api.get(`/unit/applications/${viewingDocument._id}/document`, {
        responseType: "blob",
      });
      const contentType = response.headers?.["content-type"] || "application/octet-stream";
      const disposition = response.headers?.["content-disposition"];
      const fallbackExt = getExtensionForContentType(contentType);
      const fileName =
        parseFileNameFromDisposition(disposition) ||
        `${viewingDocument.studentSicilNo}_basvuru${fallbackExt}`;
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);
      triggerDownloadFromUrl(url, fileName);
      try { window.URL.revokeObjectURL(url); } catch {}
    } catch (error) {
      console.error("Belge indirilirken hata:", error);
      // Fallback: try to use preview PDF (already rendered) or fetch preview
      try {
        if (documentUrl) {
          const fallbackName = `${viewingDocument.studentSicilNo || viewingDocument._id}_basvuru.pdf`;
          triggerDownloadFromUrl(documentUrl, fallbackName);
          return;
        }
        const previewResp = await api.get(`/unit/applications/${viewingDocument._id}/document`, {
          responseType: "blob",
          params: { preview: 1 }
        });
        const previewBlob = new Blob([previewResp.data], { type: "application/pdf" });
        const previewUrl = window.URL.createObjectURL(previewBlob);
        const fallbackName = `${viewingDocument.studentSicilNo || viewingDocument._id}_basvuru.pdf`;
        triggerDownloadFromUrl(previewUrl, fallbackName);
        try { window.URL.revokeObjectURL(previewUrl); } catch {}
        return;
      } catch {}
      alert("Belge indirilemedi");
    }
  };

  // Fetch asil-yedek PDF when tab is active or applications change
  useEffect(() => {
    if (activeTab === "asil-yedek") {
      fetchAsilYedekPdf();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeTab, applications]);

  const fetchAsilYedekPdf = async () => {
    try {
      const userData = getUnitUser();
      if (!userData?.sicilNo) return;
      const response = await api.get(`/unit/${userData.sicilNo}/asil-yedek-list-pdf`, {
        responseType: "blob"
      });
      // revoke previous URL to prevent leaks
      if (asilYedekPdfUrl) {
        window.URL.revokeObjectURL(asilYedekPdfUrl);
      }
      const url = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
      setAsilYedekPdfUrl(url);
    } catch (e) {
      setAsilYedekPdfUrl(null);
    }
  };

  // new: render asil-yedek PDF into canvas container whenever URL changes
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (activeTab === "asil-yedek" && asilYedekPdfUrl) {
      renderAsilYedekPdf(asilYedekPdfUrl);
    }
  }, [activeTab, asilYedekPdfUrl]);

  // Download current Asil-Yedek PDF blob shown in the viewer
  // Download - HTML'den PDF oluştur


  const checkShortagesBeforeFinalize = async () => {
  try {
    const userData = getUnitUser();
    if (!userData?.sicilNo) return false;
    const resp = await api.get(`/unit/${userData.sicilNo}/asil-yedek/shortages`);
    if (resp.data.success && resp.data.data?.shortages?.length > 0) {
      setShortages(resp.data.data.shortages);
      setSelectedPromotions({});
      setPromotionModalOpen(true);
      return false;
    }
    return true;
  } catch (e) {
    alert(e.response?.data?.message || "Eksik kontenjan kontrolü yapılamadı");
    return false;
  }
};

// Terfi seçim toggle (limit: eksik kadar seçim)
const togglePromotionSelect = (workplaceId, applicationId, limit) => {
  setSelectedPromotions(prev => {
    const next = { ...prev };
    const setForWp = new Set(next[workplaceId] || []);
    if (setForWp.has(applicationId)) {
      setForWp.delete(applicationId);
    } else {
      if (setForWp.size >= limit) return prev;
      setForWp.add(applicationId);
    }
    next[workplaceId] = setForWp;
    return next;
  });
};

// Seçilen yedekleri ASIL yap
const confirmPromotions = async () => {
  try {
    const userData = getUnitUser();
    if (!userData?.sicilNo) return;
    const applicationIds = Object.values(selectedPromotions)
      .flatMap(setVal => Array.from(setVal));
    if (applicationIds.length === 0) {
      alert("Terfi için en az bir aday seçiniz.");
      return;
    }
    setPromoting(true);
    const resp = await api.post(`/unit/${userData.sicilNo}/asil-yedek/promote`, { applicationIds });
    if (resp.status === 200 || resp.status === 207) {
      const ok = resp.data?.data?.promoted?.length || 0;
      const errs = resp.data?.data?.errors?.length || 0;
      alert(errs ? `Terfi tamamlandı: ${ok} başarılı, ${errs} hata.` : "Terfiler başarılı.");
      setPromotionModalOpen(false);
      setShortages([]);
      setSelectedPromotions({});
      fetchUnitApplications({ silent: true });
    }
  } catch (e) {
    console.error("Promote error:", e);
    alert(e.response?.data?.message || "Terfi yapılırken hata oluştu");
  } finally {
    setPromoting(false);
  }
};

// HTML'den PDF oluştur (helper function)
const generatePdfFromHtml = async () => {
  const wrapper = document.getElementById('printable-pdf-wrapper');
  if (!wrapper) {
    throw new Error("PDF içeriği bulunamadı");
  }

  // html2canvas ve jspdf kontrolü
  if (!window.html2canvas || !window.jspdf) {
    throw new Error("PDF kütüphaneleri yüklü değil");
  }

  const canvas = await window.html2canvas(wrapper, {
    scale: 2,
    useCORS: true,
    logging: false,
    backgroundColor: '#ffffff',
    windowWidth: 1400,
    windowHeight: wrapper.scrollHeight
  });
  
  const imgData = canvas.toDataURL('image/png');
  const pdf = new window.jspdf.jsPDF({
    orientation: 'portrait',
    unit: 'mm',
    format: 'a4'
  });
  
  const imgWidth = 210; // A4 width in mm
  const pageHeight = 297; // A4 height in mm
  const imgHeight = (canvas.height * imgWidth) / canvas.width;
  let heightLeft = imgHeight;
  let position = 0;

  // İlk sayfa
  pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  heightLeft -= pageHeight;

  // Çok uzunsa sayfa ekle
  while (heightLeft > 0) {
    position = heightLeft - imgHeight;
    pdf.addPage();
    pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
    heightLeft -= pageHeight;
  }
  
  return pdf.output('blob');
};

// Listeyi finalize et (shortage kontrolü + HTML'den PDF oluştur + backend'e gönder)
const finalizeAsilYedekList = async () => {
  try {
    const canFinalize = await checkShortagesBeforeFinalize();
    if (!canFinalize) {
      alert("Kontenjanı dolmayan alanlar var. Yedeklerden ASIL seçimi yapınız.");
      return;
    }
    if (!window.confirm("Listeyi onaylayıp kaydetmek istiyor musunuz?")) return;
    
    const userData = getUnitUser();
    if (!userData?.sicilNo) return;

    // HTML içeriğinden PDF oluştur
    let pdfBlob;
    try {
      pdfBlob = await generatePdfFromHtml();
    } catch (pdfError) {
      console.error("PDF oluşturma hatası:", pdfError);
      alert("PDF oluşturulurken hata oluştu: " + pdfError.message);
      return;
    }

    // PDF'i FormData ile backend'e gönder
    const formData = new FormData();
    formData.append('pdf', pdfBlob, 'asil-yedek-listesi.pdf');

    const finalizeResp = await api.post(
      `/unit/${userData.sicilNo}/asil-yedek/finalize`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    if (finalizeResp.data?.success) {
      alert("Liste onaylandı ve kaydedildi.");

      // Soft refresh: PDF ve tabloyu yeniden getir ve render et
      try {
        // temizle (varsa) önceki document viewer URL'leri
        if (documentUrl) {
          try { window.URL.revokeObjectURL(documentUrl); } catch {}
          setDocumentUrl(null);
          setViewingDocument(null);
        }
        await fetchAsilYedekRows();
        await fetchAsilYedekPdf();
        setActiveTab("asil-yedek");
        setPromotionModalOpen(false);
        setShortages([]);
        setSelectedPromotions({});
      } catch (refreshErr) {
        console.warn("Yenileme sırasında hata:", refreshErr);
      }
    }
  } catch (e) {
    console.error("Finalize error:", e);
    const msg = e.response?.data?.message || "Liste onaylanırken hata oluştu";
    const details = e.response?.data?.details;
    alert(details && Array.isArray(details) ? `${msg}\n- ${details.join('\n- ')}` : msg);
  }
};

// Listeyi finalize et (shortage kontrolü + HTML'den PDF oluştur + backend'e gönder) - alternatif versiyon
const finalizeAsilYedekList2 = async () => {
  try {

    if (!window.confirm("Listeyi onaylayıp kaydetmek istiyor musunuz?")) return;
    
    const userData = getUnitUser();
    if (!userData?.sicilNo) return;

    // HTML içeriğinden PDF oluştur
    let pdfBlob;
    try {
      pdfBlob = await generatePdfFromHtml();
    } catch (pdfError) {
      console.error("PDF oluşturma hatası:", pdfError);
      alert("PDF oluşturulurken hata oluştu: " + pdfError.message);
      return;
    }

    // PDF'i FormData ile backend'e gönder
    const formData = new FormData();
    formData.append('pdf', pdfBlob, 'asil-yedek-listesi.pdf');

    const finalizeResp = await api.post(
      `/unit/${userData.sicilNo}/asil-yedek/finalize`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    );

    if (finalizeResp.data?.success) {
      alert("Liste onaylandı ve kaydedildi.");

      // Soft refresh: PDF ve tabloyu yeniden getir ve render et
      try {
        if (documentUrl) {
          try { window.URL.revokeObjectURL(documentUrl); } catch {}
          setDocumentUrl(null);
          setViewingDocument(null);
        }
        await fetchAsilYedekRows();
        await fetchAsilYedekPdf();
        setActiveTab("asil-yedek");
        setPromotionModalOpen(false);
        setShortages([]);
        setSelectedPromotions({});
      } catch (refreshErr) {
        console.warn("Yenileme sırasında hata:", refreshErr);
      }
    }
  } catch (e) {
    console.error("Finalize error:", e);
    const msg = e.response?.data?.message || "Liste onaylanırken hata oluştu";
    const details = e.response?.data?.details;
    alert(details && Array.isArray(details) ? `${msg}\n- ${details.join('\n- ')}` : msg);
  }
};

  // Pagination helpers for Başvurular list
  const indexOfLastApplication = currentPage * applicationsPerPage;
  const indexOfFirstApplication = indexOfLastApplication - applicationsPerPage;
  const currentApplications = applications.slice(indexOfFirstApplication, indexOfLastApplication);
  const totalPages = Math.ceil(applications.length / applicationsPerPage);

  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((p) => p + 1);
  };
  const goToPrevPage = () => {
    if (currentPage > 1) setCurrentPage((p) => p - 1);
  };

  // Keep currentPage clamped on applications length change
  useEffect(() => {
    const tp = Math.ceil(applications.length / applicationsPerPage) || 1;
    setCurrentPage(prev => (prev > tp ? tp : (prev < 1 ? 1 : prev)));
  }, [applications, applicationsPerPage]);

  // Re-render PDFs on window resize (responsive)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const handleResize = () => {
      if (resizeTimerRef.current) clearTimeout(resizeTimerRef.current);
      resizeTimerRef.current = setTimeout(() => {
        // Re-render the student application PDF if visible
        if (viewingDocument && documentUrl && !documentPreviewLoading && !documentPreviewError && pdfContainerRef.current) {
          renderPdf(documentUrl);
        }
        // Re-render the Asil-Yedek list PDF if tab is active
        if (activeTab === "asil-yedek" && asilYedekPdfUrl && asilYedekContainerRef.current) {
          renderAsilYedekPdf(asilYedekPdfUrl);
        }
      }, 150);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      if (resizeTimerRef.current) clearTimeout(resizeTimerRef.current);
    };
  }, [viewingDocument, documentUrl, documentPreviewLoading, documentPreviewError, activeTab, asilYedekPdfUrl]);

  useEffect(() => {
    const token = localStorage.getItem("token");
    const expStr = localStorage.getItem("tokenExpiresAt");
    if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
    if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    if (expStr) {
      const msLeft = parseInt(expStr, 10) - Date.now();
      if (msLeft <= 0) {
        handleLogout();
      } else {
        logoutTimerRef.current = setTimeout(() => handleLogout(), msLeft);
      }
    }
    return () => {
      if (logoutTimerRef.current) clearTimeout(logoutTimerRef.current);
    };
  }, []);

  const handleLogout = () => {
    try { delete api.defaults.headers.common["Authorization"]; } catch {}
    localStorage.removeItem("token");
    localStorage.removeItem("tokenExpiresAt");
    localStorage.removeItem("user");
    localStorage.removeItem("unitUser");
    sessionStorage.removeItem("unitUser");
    navigate("/");
  };

  const openNotifications = async () => { await fetchNotifications({ silent: false }); setNotifOpen(true); };
  const closeNotifications = () => setNotifOpen(false);

  const markOneRead = async (id) => {
    try {
      await api.patch(`/unit/notifications/${id}/read`);
      setNotifications(prev => prev.map(n => n._id === id ? { ...n, goruldu: true } : n));
      setUnreadCount(prev => Math.max(0, prev - 1));
    } catch {}
  };

  const markAllRead = async () => {
    try {
      const user = getUnitUser();
      if (!user?.sicilNo) return;
      await api.patch(`/unit/notifications/${user.sicilNo}/read-all`);
      setNotifications(prev => prev.map(n => ({ ...n, goruldu: true })));
      setUnreadCount(0);
    } catch {}
  };

  const timeAgo = (d) => {
    try {
      const ts = new Date(d).getTime();
      const diff = Math.max(0, Date.now() - ts);
      const mins = Math.floor(diff / 60000);
      if (mins < 1) return "az önce";
      if (mins < 60) return `${mins} dk önce`;
      const hrs = Math.floor(mins / 60);
      if (hrs < 24) return `${hrs} saat önce`;
      const days = Math.floor(hrs / 24);
      return `${days} gün önce`;
    } catch { return ""; }
  };

  const HeaderActions = () => (
    <div className="header-actions">
      <button
        className="header-icon-btn"
        title="Bildirimler"
        onClick={openNotifications}
        style={{ background: unreadCount > 0 ? "#e9f7ef" : "#fff", position: "relative" }}
      >
        <i className="fa-solid fa-bell"></i>
        {unreadCount > 0 && (
          <span style={{
            position: "absolute", top: -6, right: -6, minWidth: 18, height: 18,
            padding: "0 4px", background: "#d72538", color: "#fff", borderRadius: 12,
            fontSize: 11, lineHeight: "18px", textAlign: "center", boxShadow: "0 1px 4px rgba(0,0,0,0.2)"
          }}>
            {unreadCount > 99 ? "99+" : unreadCount}
          </span>
        )}
      </button>
      <button className="header-icon-btn" title="Çıkış Yap" onClick={handleLogout}>
        <i className="fa-solid fa-arrow-right-from-bracket"></i>
      </button>
    </div>
  );

  // NEW: initial check for monthly availability (active employees)
  useEffect(() => {
    (async () => {
      try {
        const user = getUnitUser();
        if (!user?.sicilNo) return;
        const resp = await api.get(`/unit/${user.sicilNo}/monthly-timesheet`, { params: { meta: 1 } });
        setMonthlyAvailable((resp.data?.meta?.employeeCount || 0) > 0);
      } catch {
        setMonthlyAvailable(false);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // NEW: fetch monthly summary for selected month
  const fetchMonthly = async (m) => {
    try {
      const user = getUnitUser();
      if (!user?.sicilNo) return;
      setMonthlyLoading(true);
      const resp = await api.get(`/unit/${user.sicilNo}/monthly-timesheet`, { params: { month: m || monthlyMonth } });
      if (resp.data?.success) setMonthlyData(resp.data.data || null);
      else setMonthlyData(null);
    } catch {
      setMonthlyData(null);
    } finally {
      setMonthlyLoading(false);
    }
  };

  // Download - aynı PDF'i indir
const downloadAsilYedekPdf = async () => {
  try {
    const pdfBlob = await generatePdfFromHtml();
    const url = window.URL.createObjectURL(pdfBlob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'asil-yedek-listesi.pdf';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("PDF download error:", error);
    alert("PDF indirilirken hata oluştu: " + error.message);
  }
};

  // NEW: load monthly data when tab opens
  useEffect(() => {
    if (activeTab === "aylik" && monthlyAvailable) {
      fetchMonthly(monthlyMonth);
    }
  }, [activeTab, monthlyAvailable]); // eslint-disable-line react-hooks/exhaustive-deps

  // NEW: handler passed to UnitMonthlyTable
  const onChangeMonthlyMonth = (m) => {
    setMonthlyMonth(m);
    fetchMonthly(m);
  };


  // Fetch asil/yedek belge göndermiş öğrenciler
  const fetchAsilYedekRows = async () => {
    try {
      const userData = getUnitUser();
      if (!userData?.sicilNo) return;
      // Backend'den asil/yedek ve belge göndermiş öğrencileri çek
      const resp = await api.get(`/unit/${userData.sicilNo}/applications`);
      if (resp.data?.success) {
        // Sadece asil/yedek ve belge göndermiş olanları filtrele
        const rows = (resp.data.data.applications || [])
          .filter(a => (a.status === "asil" || a.status === "yedek") && a.hasSubmittedDocuments)
          .map((a, idx) => ({
            sira: idx + 1,
            tcKimlik: a.studentTcNo,
            adSoyad: a.studentName,
            gorevi: a.workplaceInfo
              ? `${a.workplaceInfo.calisacakYer} - ${a.workplaceInfo.isAdi}`
              : "",
            durum: a.status === "asil" ? "Asil" : "Yedek"
          }));
        setAsilYedekRows(rows);
      }
    } catch (e) {
      setAsilYedekRows([]);
    }
  };

  // Asil-Yedek tabı açıldığında verileri çek
  useEffect(() => {
    if (activeTab === "asil-yedek") {
      fetchAsilYedekRows();
      fetchAsilYedekPdf();
    }
  }, [activeTab, applications]); // eslint-disable-line react-hooks/exhaustive-deps

  // NEW: edit mode state for monthly table
  const [monthlyEditing, setMonthlyEditing] = useState(false);
  const [monthlyDraft, setMonthlyDraft] = useState(null);

  // NEW: onaylama fonksiyonu (şimdilik boş)
  const handleMonthlyApprove = async () => {
    try {
      const user = getUnitUser();
      if (!user?.sicilNo) return;
      if (!window.confirm("Bu ayın tablosunu onaylamak ve admine bildirim göndermek istiyor musunuz?")) return;
      const resp = await api.post(`/unit/${user.sicilNo}/monthly-timesheet/approve`, {
        month: monthlyMonth
      });
      if (resp.data?.success) {
        alert("Aylık tablo onaylandı ve admine bildirildi!");
        // İsteğe bağlı: tabloyu yeniden yükleyin
        await fetchMonthly(monthlyMonth);
      } else {
        alert(resp.data?.message || "Onaylama başarısız oldu.");
      }
    } catch (err) {
      console.error(err);
      alert("Bir hata oluştu.");
    }
  };

  

  const saveMonthlyUpdates = async () => {
    try {
      const user = getUnitUser();
      if (!user?.sicilNo) return;
      const hourlyWage = 88.90; // İsterseniz localStorage'dan da alabilirsiniz
      const updates = monthlyDraft.map(r => ({
        studentSicilNo: r.studentSicilNo,
        perDay: r.perDay
      }));

      const resp = await api.post(`/unit/${user.sicilNo}/monthly-update`, {
        month: monthlyMonth,
        updates,
        hourlyWage
      });

      if (resp.data?.success) {
        alert("Değişiklikler kaydedildi!");
        setMonthlyEditing(false);
        setMonthlyDraft(null);
        await fetchMonthly(monthlyMonth); // tabloyu yeniden yükle
      } else {
        alert("Kaydetme başarısız oldu.");
      }
    } catch (err) {
      console.error(err);
      alert("Bir hata oluştu.");
    }
  };

  return (
    <div className="unit-page-wrapper">
      <header className="unit-header">
        <div className="header-content">
          <img src={kouLogo} alt="KOU Logo" className="header-logo" />
          <h1 className="header-title">
            Kısmi Zamanlı Öğrenci Süreç Takip Sistemi
          </h1>
          <HeaderActions /> {/* NEW */}
        </div>
      </header>

      <main className="unit-main">
        <div className="unit-tabs">
          <div className="tabs-left">
            <button
              className={`unit-tab-btn ${activeTab === "basvurular" ? "active" : ""}`}
              onClick={() => setActiveTab("basvurular")}
            >
              {unitData ? unitData.birimAdi : "Başvurular"}
            </button>
            <button
              className={`unit-tab-btn ${activeTab === "asil-yedek" ? "active" : ""}`}
              onClick={() => setActiveTab("asil-yedek")}
            >
              Asil-Yedek Listesi
            </button>
            {monthlyAvailable && (
              <>

                <button
                  className={`unit-tab-btn ${activeTab === "aylik" ? "active" : ""}`}
                  onClick={() => setActiveTab("aylik")}
                  title="Aylık Takip"
                >
                  Aylık Takip
                </button>
              </>
            )}
          </div>
          
          {unitData && (
            <div className="unit-info">
              <div className="capacity-info">
                {unitData.totalKapasite}
              </div>
              {/* NEW: subtle spinner to indicate background refresh */}
              {refreshing && (
                <i
                  className="fa-solid fa-spinner fa-spin"
                  title="Güncelleniyor"
                  style={{ marginLeft: 8, color: "#1ea54e", fontSize: 14 }}
                />
              )}
            </div>
          )}
        </div>

        <div className="unit-tab-content">
                                        
          {activeTab === "basvurular" && (
            <div className="applications-container">
              {viewingDocument ? (
                <div className="document-shell">
                  <button
                    className="side-btn back-side"
                    onClick={backToApplications}
                    title="Geri Dön"
                  >
                    <i className="fa-solid fa-chevron-left"></i>
                  </button>

                  <div className="document-viewer">
                    <div className="document-content">
                      {documentPreviewLoading ? (
                        <div className="pdf-render-container">
                          <div className="non-pdf-message">
                            <i className="fa-solid fa-file" style={{ marginRight: 8 }}></i>
                            <span>PDF hazırlanıyor...</span>
                          </div>
                        </div>
                      ) : documentPreviewError ? (
                        <div className="pdf-render-container">
                          <div className="non-pdf-message">
                            <i className="fa-solid fa-triangle-exclamation" style={{ marginRight: 8 }}></i>
                            <span>{documentPreviewError}</span>
                          </div>
                        </div>
                      ) : (
                        <div ref={pdfContainerRef} className="pdf-render-container">
                          {/* PDF canvas pages will be rendered here */}
                        </div>
                      )}
                    </div>
                  </div>

                  <button
                    className="side-btn download-side"
                    onClick={downloadCurrentDocument}
                    title="İndir"
                  >
                    <i className="fa-solid fa-download"></i>
                  </button>
                </div>
              ) : (
                <>
                  {loading ? (
                    <div className="loading-state">
                      <p>Yükleniyor...</p>
                    </div>
                  ) : applications.length === 0 ? (
                    <div className="unit-empty-state">
                      <img src={studentHomeImg2} alt="Boş içerik" className="unit-empty-img2" />
                      <p>
                        Henüz başvuru bulunmamaktadır.
                      </p>
                    </div>
                  ) : (
                    <div className="unit-applications-list">
                      <div className="unit-status-legend">
                        <h5>Renk Kodlaması :</h5>
                        <div className="unit-legend-items">
                          <div className="unit-legend-item">
                            <div className="unit-legend-color beklemede"></div>
                            <span>: Beklemede</span>
                          </div>
                          <div className="unit-legend-item">
                            <div className="unit-legend-color reddedildi"></div>
                            <span>: Reddedildi</span>
                          </div>
                          <div className="unit-legend-item">
                            <div className="unit-legend-color yedek"></div>
                            <span>: Yedek</span>
                          </div>
                          <div className="unit-legend-item">
                            <div className="unit-legend-color asil"></div>
                            <span>: Asil</span>
                          </div>
                        </div>
                      </div>

                      <div className="applications-content">
                        {currentApplications.map((application) => (
                          <div key={application._id} className={`unit-application-item ${application.status}`}>
                            <div className="application-info">
                              <div className="student-info">
                                <h3>{application.studentName} - {application.studentSicilNo}</h3>
                                <div className="workplace-info">
                                  <span className="workplace-text">
                                    {application.workplaceInfo?.calisacakYer} - {application.workplaceInfo?.isAdi}
                                  </span>
                                  <div className="workplace-capacity">
                                    <span className="capacity-text">
                                      Kapasite: {application.workplaceInfo?.kapasite}
                                    </span>
                                  </div>
                                  {application.hasSubmittedDocuments && (
                                    <div className="document-status">
                                      <span className="document-submitted-text">
                                        ✓ Belgeler gönderildi
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>
                              
                              <div className="application-actions">
                                <div className="status-buttons">
                                  <button 
                                    className={`status-btn view-btn`}
                                    onClick={() => viewDocument(application)}
                                    title="Detayları Görüntüle"
                                  >
                                    <i className="fa-solid fa-eye"></i>
                                  </button>
                                  <button 
                                    className={`status-btn asil ${application.status === 'asil' ? 'active' : ''} ${
                                      (!application.canChangeStatus || application.priorAsilSubmissionExists) ? 'disabled' : ''
                                    }`}
                                    onClick={() =>
                                      (!application.canChangeStatus || application.priorAsilSubmissionExists)
                                        ? null
                                        : updateApplicationStatus(application._id, 'asil')
                                    }
                                    title={
                                      !application.canChangeStatus
                                        ? (application.lockedByAsil
                                            ? "Aynı birimde bir ASIL seçimi olduğu için bu başvuru kilitli"
                                            : "Öğrenci belge gönderdiği için durum değiştirilemez")
                                        : (application.priorAsilSubmissionExists
                                            ? "Öğrenci daha önce ASIL için belgelerini göndermiş. Tekrar ASIL seçilemez."
                                            : "Asil Olarak İşaretle")
                                    }
                                    disabled={!application.canChangeStatus || application.priorAsilSubmissionExists}
                                  >
                                    <i className="fa-solid fa-check"></i>
                                  </button>
                                  <button 
                                    className={`status-btn yedek ${application.status === 'yedek' ? 'active' : ''} ${!application.canChangeStatus ? 'disabled' : ''}`}
                                    onClick={() => application.canChangeStatus && updateApplicationStatus(application._id, 'yedek')}
                                    title={
                                      !application.canChangeStatus
                                        ? (application.lockedByAsil
                                            ? "Aynı birimde bir ASIL seçimi olduğu için bu başvuru kilitli"
                                            : "Öğrenci belge gönderdiği için durum değiştirilemez")
                                        : "Yedek Olarak İşaretle"
                                    }
                                    disabled={!application.canChangeStatus}
                                  >
                                    <i className="fa-solid fa-check"></i>
                                  </button>
                                  <button 
                                    className={`status-btn reddedildi ${application.status === 'reddedildi' ? 'active' : ''} ${!application.canChangeStatus ? 'disabled' : ''}`}
                                    onClick={() => application.canChangeStatus && updateApplicationStatus(application._id, 'reddedildi')}
                                    title={
                                      !application.canChangeStatus
                                        ? (application.lockedByAsil
                                            ? "Aynı birimde bir ASIL seçimi olduğu için bu başvuru kilitli"
                                            : "Öğrenci belge gönderdiği için durum değiştirilemez")
                                        : "Reddet"
                                    }
                                    disabled={!application.canChangeStatus}
                                  >
                                    <i className="fa-solid fa-xmark"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            
                            <div className={`status-indicator ${application.status}`}>
                              {application.status === 'beklemede' ? 'Beklemede' : 
                               application.status === 'asil' ? 'Asil' :
                               application.status === 'yedek' ? 'Yedek' : 'Reddedildi'}
                            </div>
                          </div>
                        ))}
                      </div>

                      {/* Pagination Controls */}
                      {totalPages > 1 && (
                        <div className="pagination-container">
                          <div className="pagination">
                            <button 
                              className="pagination-btn prev-btn"
                              onClick={goToPrevPage}
                              disabled={currentPage === 1}
                              title="Önceki Sayfa"
                            >
                              <i className="fa-solid fa-chevron-left"></i>
                            </button>
                            
                            <div className="page-numbers">
                              <span className="page-indicator">
                                {currentPage}
                              </span>
                            </div>
                            
                            <button 
                              className="pagination-btn next-btn"
                              onClick={goToNextPage}
                              disabled={currentPage === totalPages}
                              title="Sonraki Sayfa"
                            >
                              <i className="fa-solid fa-chevron-right"></i>
                            </button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}
            </div>
          )}

          {/* Yeni tab içeriği: asil-yedek listesi (rendered with PDF.js, no viewer UI) */}
          {activeTab === "asil-yedek" && (
            <div className="applications-container">
              <div className="document-shell asil-yedek-shell">
                <div className="document-viewer">
                  <div className="document-content">
                    <div ref={asilYedekContainerRef} className="pdf-render-container">
                      {/* PDF.js canvases will be rendered here */}
                    </div>
                  </div>
                </div>
                <button
                  className="side-btn download-side"
                  onClick={downloadAsilYedekPdf}
                  title="İndir"
                >
                  <i className="fa-solid fa-download"></i>
                </button>
                <button
                  className="side-btn verify-side"
                  onClick={finalizeAsilYedekList}
                  title="Listeyi Onayla"
                >
                  <i className="fa-solid fa-check"></i>
                </button>
              </div>
            </div>
          )}

          {/* NEW: Öğrenci Listesi */}
          
          {/* NEW: Aylık Takip */}
          {activeTab === "aylik" && (
            <div className="applications-container">
              <UnitMonthlyTable
                data={
                  monthlyEditing
                    ? monthlyData
                      ? { ...monthlyData, rows: monthlyDraft, month: monthlyMonth }
                      : null
                    : monthlyData
                      ? { ...monthlyData, month: monthlyMonth }
                      : null
                }
                loading={monthlyLoading}
                onMonthChange={onChangeMonthlyMonth}
                editable={monthlyEditing}
                onCellChange={(sicilNo, day, value) => {
                  setMonthlyDraft(prev => {
                    const updated = prev ? [...prev] : [];
                    const row = updated.find(r => r.studentSicilNo === sicilNo);
                    if (row) {
                      row.perDay[String(day)] = value;
                      row.totalHours = Object.values(row.perDay).reduce((a, b) => a + Number(b || 0), 0);
                    }
                    return updated;
                  });
                }}
                onApprove={handleMonthlyApprove}
              />
              <div className="umt-monthly-side-btn-group">
                {!monthlyEditing ? (
                  <button
                    className="umt-monthly-side-btn"
                    onClick={() => {
                      setMonthlyEditing(true);
                      setMonthlyDraft(monthlyData?.rows ? JSON.parse(JSON.stringify(monthlyData.rows)) : []);
                    }}
                    title="Güncelle"
                  >
                    <i className="fa-solid fa-pen"></i>
                  </button>
                ) : (
                  <>
                    <button
                      className="umt-monthly-side-btn save"
                      onClick={saveMonthlyUpdates}
                      title="Kaydet"
                    >
                      <i className="fa-solid fa-check"></i>
                    </button>
                    <button
                      className="umt-monthly-side-btn cancel"
                      onClick={() => {
                        setMonthlyEditing(false);
                        setMonthlyDraft(null);
                      }}
                      title="İptal"
                    >
                      <i className="fa-solid fa-times"></i>
                    </button>
                  </>
                )}
                {!monthlyEditing ? (
                  <button
                    className="umt-monthly-side-btn"
                    onClick={handleMonthlyApprove}
                    title="Onayla"
                  >
                    <i className="fa-solid fa-check"></i>
                  </button>
                ) : null}
                                          <button
                            className="umt-monthly-side-btn"
                            title="Excel İndir"
                              onClick={downloadMonthlyExcel}

                          >
                            <i className="fa-solid fa-download"></i>
                          </button>
              </div>
            </div>
          )}

 {/* Promotion Modal */}
{promotionModalOpen && (
  <div className="modal-overlay" onClick={() => !promoting && setPromotionModalOpen(false)}>
    <div className="student-info-modal promotion-modal" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <h3>Eksik Kontenjanlar - Yedekten ASIL Seçimi</h3>
        <button
          className="modal-close-btn"
          onClick={() => !promoting && setPromotionModalOpen(false)}
        >
          ×
        </button>
      </div>

      <div className="modal-body scrollable">
        {shortages.length === 0 ? (
          <p>Tüm kontenjanlar dolu görünüyor.</p>
        ) : (
          <>
            <p className="promotion-warning">
              Kontenjanı doldurmak için yedeklerden asil seçebilirsiniz. Doldurmak zorunda değilsiniz, "Devam Et" ile eksik kontenjanla onaylayabilirsiniz.
            </p>
            {shortages.map((s) => {
              const picked = selectedPromotions[s.workplaceId]?.size || 0;
              return (
                <div key={s.workplaceId} className="promotion-block">
                  <h4 className="promotion-title">
                    {s.workplaceName} — Eksik: {s.missing} / Kapasite: {s.kapasite}
                    {picked > 0 ? ` (Seçildi: ${picked})` : ""}
                  </h4>

                  {s.candidates.length === 0 ? (
                    <div className="no-candidate-text">Uygun yedek aday bulunamadı.</div>
                  ) : (
                    <ul className="candidate-list">
                      {s.candidates.map((c) => {
                        const disabled =
                          (selectedPromotions[s.workplaceId]?.size || 0) >= s.missing &&
                          !selectedPromotions[s.workplaceId]?.has(c.applicationId);
                        const checked = selectedPromotions[s.workplaceId]?.has(c.applicationId) || false;

                        return (
                          <li key={c.applicationId} className="candidate-item">
                            <input
                              type="checkbox"
                              checked={checked}
                              disabled={disabled || promoting}
                              onChange={() =>
                                togglePromotionSelect(s.workplaceId, c.applicationId, s.missing)
                              }
                            />
                            <span className="candidate-info">
                              {c.studentName} — {c.studentSicilNo}
                              {c.submissionDate
                                ? ` (Belge: ${new Date(c.submissionDate).toLocaleDateString(
                                    "tr-TR"
                                  )})`
                                : ""}
                            </span>
                          </li>
                        );
                      })}
                    </ul>
                  )}
                  <hr />
                </div>
              );
            })}
          </>
        )}
      </div>

      <div className="modal-footer">
        <button className="cancel-btn" disabled={promoting} onClick={() => setPromotionModalOpen(false)}>
          İptal
        </button>
        <button className="confirm-btn" disabled={promoting} onClick={confirmPromotions}>
          {promoting ? "İşleniyor..." : "Seçilenleri ASIL Yap"}
        </button>
        <button
          className="confirm-btn"
          disabled={promoting}
          style={{ background: "#1ea54e", marginLeft: 8 }}
          onClick={() => {
            setPromotionModalOpen(false);
            finalizeAsilYedekList2();
          }}
        >
          Devam Et
        </button>
      </div>
    </div>
  </div>
)}

        </div>
      </main>

      {/* NEW: Notifications Modal */}
      {notifOpen && (
        <div className="modal-overlay" onClick={closeNotifications}>
          <div
            className="student-info-modal"
            onClick={(e) => e.stopPropagation()}
            style={{ maxWidth: 680 }}
          >
            <div className="modal-header">
              <h3>Bildirimler</h3>
              <div style={{ marginLeft: "auto", display: "inline-flex", gap: 8 }}>
                <button className="confirm-btn" onClick={markAllRead} disabled={unreadCount === 0}>
                  Tümünü Okundu İşaretle
                </button>
                <button className="modal-close-btn" onClick={closeNotifications}>×</button>
              </div>
            </div>
            <div className="modal-body" style={{ maxHeight: 520, overflowY: "auto", paddingTop: 8 }}>
              {notifLoading ? (
                <div style={{ padding: 12, color: "#666", fontSize: 14 }}>Yükleniyor...</div>
              ) : notifications.length === 0 ? (
                <div style={{ padding: 12, color: "#666", fontSize: 14 }}>Gösterilecek bildiriminiz yok.</div>
              ) : (
                <ul style={{ listStyle: "none", padding: 0, margin: 0 }}>
                  {notifications.map(n => (
                    <li key={n._id} style={{
                      display: "grid", gridTemplateColumns: "1fr auto", gap: 8, padding: "10px 8px",
                      borderBottom: "1px solid #eee", background: n.goruldu ? "#fff" : "#f9fffb"
                    }}>
                      <div>
                        <div style={{ fontSize: 14, color: "#111827", fontWeight: n.goruldu ? 400 : 600 }}>{n.message}</div>
                        <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 2 }}>{timeAgo(n.saat || n.createdAt)}</div>
                      </div>
                      <div>
                        {!n.goruldu && (
                          <button className="cancel-btn" onClick={() => markOneRead(n._id)} style={{ padding: "6px 10px" }}>
                            Okundu
                          </button>
                        )}
                      </div>
                    </li>
                  ))}
                </ul>
              )}
            </div>
          </div>
        </div>
      )}

   
    </div>
  );
}

export default UnitHomePage;
